import Main from './Main.vue'
import SearchResult from './SearchResult.vue'
import SwitchToEnvironment from './SwitchToEnvironment.vue'

const routes = [
  {
    name: 'dashboard/main',
    component: Main,
    path: '/home',
    props: (route) => ({ switchToEnvironment: route.query.switch_to_environment }),
  },
  {
    name: 'dashboard/search',
    component: SearchResult,
    path: '/search',
    props: (route) => ({ query: route.query.q }),
  },
  {
    name: 'dashboard/switch_to_environment',
    component: SwitchToEnvironment,
    path: '/switch_to_environment/:environmentId',
    meta: {
      requiresAuth: true,
    },
  },
]

export { routes }
